<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-mail-bulk"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="sendEmailForm">
      <div formArrayName="arrayToRecipients">
        <div class="form-group row mb-1" *ngFor="let group of arrayToRecipients.controls; let index= index"
             [formGroupName]="index">
          <label class="col-md-3 font-weight-bold"
                 for="recipientToInput{{index}}">{{hasUniqueToRow ? ('LABEL.RECIPIENT' | translate) + ':' : ('LABEL.RECIPIENT' | translate) + ' ' + (index + 1) + ':'}}</label>
          <div class="{{hasUniqueToRow?'col-md-9':'col-md-8'}}">
            <input type="email"
                   id="recipientToInput{{index}}"
                   class="form-control"
                   placeholder="{{ 'MESSAGE.ENTER-EMAIL' | translate }}"
                   formControlName="to"
                   [email]="true">
            <small *ngIf="isInvalidControl2(arrayToRecipients, index,'to')"
                   class="text-danger">
              {{getErrorMessageBy(arrayToRecipients, index, 'to')}}
            </small>
          </div>
          <div class="col-md-1 icon-position" *ngIf="!hasUniqueToRow">
            <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteToRow(index)"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="offset-md-3 {{hasUniqueToRow?'col-md-9':'col-md-8'}} text-right">
          <button class="btn btn-sm btn-outline-success mb-1"
                  type="button" (click)="addToRow()">+ {{ "BUTTON.ADD" | translate }}
          </button>
        </div>
      </div>

      <div class="mt-1 mb-1" formArrayName="arrayCcRecipients">
        <div class="form-group row mb-1" *ngFor="let group of arrayCcRecipients.controls; let index2= index"
             [formGroupName]="index2">
          <label class="col-md-3 font-weight-bold"
                 for="recipientCcInput{{index2}}">{{hasUniqueCcRow ? 'Cc:' : 'Cc ' + (index2 + 1) + ':'}}</label>
          <div class="{{hasUniqueCcRow?'col-md-9':'col-md-8'}}">
            <input type="email"
                   id="recipientCcInput{{index2}}"
                   class="form-control"
                   placeholder="{{ 'MESSAGE.ENTER-EMAIL' | translate }}"
                   formControlName="cc"
                   [email]="true">
            <small *ngIf="isInvalidControl2(arrayCcRecipients, index2,'cc')"
                   class="text-danger">
              {{getErrorMessageBy(arrayCcRecipients, index2, 'cc')}}
            </small>
          </div>
          <div class="col-md-1 icon-position" *ngIf="!hasUniqueCcRow">
            <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteCcRow(index2)"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="offset-md-3 {{hasUniqueCcRow?'col-md-9':'col-md-8'}} text-right">
          <button class="btn btn-sm btn-outline-success mb-1"
                  type="button" (click)="addCcRow()">+ {{ "BUTTON.ADD" | translate }}
          </button>
        </div>
      </div>
      <div class="form-group row mt-1">
        <label for="subject" class="col-md-3 col-form-label font-weight-bold">{{ "LABEL.SUBJECT" | translate }}:</label>
        <div class="col-md-9">
          <input type="text"
                 id="subject"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-SUBJECT' | translate }}"
                 formControlName="subject"
                 [(ngModel)]="contentdeliverymail.subject">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label font-weight-bold">{{ "LABEL.WEIGHT-ATTACHMENTS" | translate }}:</label>
        <label class="col-md-9 col-form-label">{{totalLengthOnMB}}MB</label>
      </div>
      <div class="form-group row" *ngIf="isLengthMoreThan5MB">
        <label class="col-md-3 col-form-label font-weight-bold">{{ "LABEL.NOTE" | translate }}:</label>
        <label class="col-md-9 col-form-label">{{ "MESSAGE.FILE-SHOULD-NOT-EXCEED-5MB" | translate }}</label>
      </div>
      <div class="form-group row">
        <label for="subject" class="col-md-3 col-form-label font-weight-bold">{{ "LABEL.SENDING-MODE" | translate }}
          :</label>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-4">
              <div class="custom-control custom-radio">
                <input type="radio"
                       id="attachFilesRadio"
                       class="custom-control-input"
                       [value]="true"
                       formControlName="attachFiles"
                       [(ngModel)]="contentdeliverymail.attachFiles"
                       [attr.disabled]="isLengthMoreThan5MB ? '' : null">
                <label class="custom-control-label"
                       for="attachFilesRadio">{{ "LABEL.ATTACH-FILES" | translate }}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="custom-control custom-radio">
                <input type="radio"
                       id="attachURLRadio"
                       class="custom-control-input"
                       [value]="false"
                       formControlName="attachFiles"
                       [(ngModel)]="contentdeliverymail.attachFiles"
                       [attr.disabled]="isLengthMoreThan5MB ? '' : null">
                <label class="custom-control-label"
                       for="attachURLRadio">{{ "LABEL.ATTACH-URL-ONLY" | translate }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="subject" class="col-md-3 col-form-label font-weight-bold">{{ "LABEL.MESSAGE-CONTENT" | translate }}
          :</label>
        <div class="col-md-9">
          <quill-editor [styles]="{height: '200px'}"
                        [(ngModel)]="contentdeliverymail.body"
                        formControlName="body">
          </quill-editor>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="send()">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> {{ "BUTTON.SEND" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
